import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { IStringAnyMap } from 'src/app/app.types';
import { AppService } from 'src/app/service/app.service';
import { SessionService } from 'src/app/service/session.service';

@Component({
  selector: 'flow-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

  public apps : IStringAnyMap[] = [];

  constructor(
    private app : AppService,
    private session : SessionService,
    private sanitizer: DomSanitizer,
    private route : ActivatedRoute
  ){
    this.app.$apps.subscribe((apps) => this.apps = apps || []);
  }

  public safeHTML(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }


  signOut () {
    this.session.signOut().subscribe();
  }
}
